export default __webpack_public_path__ + "static/media/momo.108856d5.jpg";